"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EIP1155_DOMAIN_NFT_TEMPLATE = exports.EIP1155_DOMAIN_NFT_VERSION = exports.EIP1155_DOMAIN_NFT_NAME = exports.EIP1155_NFT_TYPE = exports.EIP721_DOMAIN_NFT_TEMPLATE = exports.EIP721_DOMAIN_NFT_VERSION = exports.EIP721_DOMAIN_NFT_NAME = exports.EIP1155_NFT_TYPES = exports.EIP721_NFT_TYPES = exports.NFT_DOMAIN_TYPE = exports.EIP721_NFT_TYPE = void 0;
exports.EIP721_NFT_TYPE = 'Mint721';
exports.NFT_DOMAIN_TYPE = [
    { type: "string", name: "name" },
    { type: "string", name: "version" },
    { type: "uint256", name: "chainId" },
    { type: "address", name: "verifyingContract" },
];
exports.EIP721_NFT_TYPES = {
    EIP712Domain: exports.NFT_DOMAIN_TYPE,
    Part: [
        { name: 'account', type: 'address' },
        { name: 'value', type: 'uint96' },
    ],
    Mint721: [
        { name: 'tokenId', type: 'uint256' },
        { name: 'tokenURI', type: 'string' },
        { name: 'creators', type: 'Part[]' },
        { name: 'royalties', type: 'Part[]' },
    ],
};
exports.EIP1155_NFT_TYPES = {
    EIP712Domain: exports.NFT_DOMAIN_TYPE,
    Part: [
        { name: 'account', type: 'address' },
        { name: 'value', type: 'uint96' }
    ],
    Mint1155: [
        { name: 'tokenId', type: 'uint256' },
        { name: 'supply', type: 'uint256' },
        { name: 'tokenURI', type: 'string' },
        { name: 'creators', type: 'Part[]' },
        { name: 'royalties', type: 'Part[]' }
    ]
};
exports.EIP721_DOMAIN_NFT_NAME = "Mint721";
exports.EIP721_DOMAIN_NFT_VERSION = "1";
exports.EIP721_DOMAIN_NFT_TEMPLATE = {
    name: exports.EIP721_DOMAIN_NFT_NAME,
    version: exports.EIP721_DOMAIN_NFT_VERSION,
};
exports.EIP1155_NFT_TYPE = 'Mint1155';
exports.EIP1155_DOMAIN_NFT_NAME = "Mint1155";
exports.EIP1155_DOMAIN_NFT_VERSION = "1";
exports.EIP1155_DOMAIN_NFT_TEMPLATE = {
    name: exports.EIP1155_DOMAIN_NFT_NAME,
    version: exports.EIP1155_DOMAIN_NFT_VERSION,
};
